export enum ProviderGuidesManagement {
  Disabled = 1,
  Full = 2
};